import React, { useState, useEffect, useCallback } from "react";
// import logo_dronewhite from "../../picture/LOGO_Dronesign.png";
import logo_dronewhite from "../../picture/AMETHYST-LOGO-removebg-preview.png";
import { Link, useNavigate } from "react-router-dom";
import logo_droneBlack from "../../picture/drone_white.png";
import { Button, Nav, NavDropdown, ToggleButton } from "react-bootstrap";
import AuthService from "../../services/auth.service";
import AuthServiceV2 from "../../services/auth.serviceV2";
import EventBus from "../../common/EventBus";
import "@fontsource/kanit";
import logoamethyst from "../../picture/AMETHYST-LOGO-removebg-preview.png";
import Static_modal from "../user/etc/Static_modal";
//import { useKeycloak } from "@react-keycloak/web";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import { margin } from "@mui/system";
import "./Styles.css";
import { useLanguage } from "../../Language/LanguageContext";
/// Child
import CaatNav from "./NavChild/Caat-Nav";
import AgencyNav from "./NavChild/Agency-Nav";
import UserNav from "./NavChild/User-Nav";
import UTMNav from "./NavChild/UTM-Nav";
import CorporationNav from "./NavChild/Corporation-Nav";
/// Child

const Navbar3 = ({ children }) => {
  //const { keycloak, initialized } = useKeycloak();
  const { t, changeLanguage, language } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);
  const [logincheck, setLogincheck] = useState(true);
  const [isAdmin, setIsAdimin] = useState(undefined);
  const [isAgency, setIsAgency] = useState(undefined);
  const [isCaat, setIsCaat] = useState(undefined);
  const [isUTM, setIsUTM] = useState(undefined); //// new Admin UTM
  const [isCorporation, setIsCorporation] = useState(undefined);
  const [checked, setChecked] = useState(false);
  const [shouldReload, setShouldReload] = useState(true);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();

  let Navigate = useNavigate();
  const handleClose = () => {
    setLoading(false);
  };

  //Dropdown
  const [show, setShow] = useState(false);
  const showDropdown = (e) => {
    setShow(!show);
  };
  const hideDropdown = (e) => {
    setShow(false);
  };
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const [showPilot, setShowPilot] = useState(false);
  const showDropdownPilot = (e) => {
    setShowPilot(!showPilot);
  };
  const hideDropdownPilot = (e) => {
    setShowPilot(false);
  };

  const [showOperation, setShowOperation] = useState(false);
  const showDropdownOperation = (e) => {
    setShowOperation(!showOperation);
  };
  const hideDropdownOperation = (e) => {
    setShowOperation(false);
  };
  const [showProfile, setShowProfile] = useState(false);
  const showDropdownProfile = (e) => {
    setShowProfile(!showProfile);
  };
  const hideDropdownProfile = (e) => {
    setShowProfile(false);
  };
  
  //#Dropdown

  async function checkadminreq() {
    if (sessionStorage.getItem("type_user") === "caat") {
      setIsAdimin(true);
      //console.log("caat");
      setCurrentUser({ f_name: "CAAT" });
    } else {
      setIsAdimin(false);
      if (sessionStorage.getItem("type_user") === "agency") {
        setIsAgency(true);
        //console.log("agency");
        setCurrentUser({ f_name: "Agency" });
      } else {
        setIsAgency(false);
        if (sessionStorage.getItem("type_user") === "nbtc") {
          setIsAdimin(true);
          setIsCaat(true);
          //console.log("nbtc");
          setCurrentUser({ f_name: "NBTC" });
        } else {
          setIsAdimin(false);
          setIsCaat(false);
          if (sessionStorage.getItem("type_user") === "admin_utm") {
            setIsUTM(true);
            setIsAdimin(true);
            //console.log("utm");
            setCurrentUser({ f_name: "ADMIN_UTM" });
          } else {
            setIsUTM(false);
            if (sessionStorage.getItem("type_user") === "corporation") {
              setIsCorporation(true);
              setCurrentUser({ f_name: "corporation" });
            } else {
              setIsCorporation(false);
            }
          }
        }
      }
    }
  }
  function checkLogin() {
    if (
      window.location.href.includes("/login") === true ||
      window.location.href.includes("/register") === true ||
      window.location.href.includes("/welcome") === true
    ) {
      setLogincheck(false);
    }

    // if (window.location.href.includes("/register") === true) {
    //   //console.log("sss");
    //   setLogincheck(undefined);
    // }
  }
  async function getuser() {
    if (
      window.location.href.includes("/login") === true ||
      window.location.href.includes("/register") === true ||
      window.location.href.includes("/welcome") === true
    ) {
      setLogincheck(undefined);
    } else {
      if (
        sessionStorage.getItem("type_user") === "caat" ||
        sessionStorage.getItem("type_user") === "agency" ||
        sessionStorage.getItem("type_user") === "nbtc" ||
        // sessionStorage.getItem("type_user") === "corporation" ||
        sessionStorage.getItem("type_user") === "admin_utm"
      ) {
        //console.log("Is Regulator and Agency");
      } else {
        const check = AuthServiceV2.getCurrentUser();
        
        if (check !== null) {
          check
            .then((result) => {
              console.log(result)
              if (typeof result === "undefined" || result === "Login expire") {
              } else {
                if (result.status !== "error" || result.status !== undefined) {
                  // console.log(result.data.data)
                  setCurrentUser(result.data.data);
                  setLoading(false);
                } else {
                  // setCurrentUser(result.data.data);
                  setLoading(true);
                }
              }
            })
            .catch((error) => {
              setTextBody(error);
              setModalToggle({ ...modalToggle, modalErr: true });
            });
        }
      }
    }
  }

  //console.log(currentUser)
  useEffect(() => {
    checkLogin();
  }, []);
  useEffect(() => {
    //connect_keycloak();
    getuser();
    ////console.log(window.location.href)
    checkadminreq();

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, []);

  const logout_key = () => {
    //keycloak.logout();
  };
  const logOut = () => {
    /*AuthVerify.setShowModeratorBoard(false);
        AuthVerify.setShowAdminBoard(false);
        AuthVerify.setCurrentUser(undefined);*/
    //keycloak.logout();
    //AuthService.logout();
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("type_user");
    sessionStorage.removeItem("pilot_id");
    sessionStorage.removeItem("pilot_code_open");
    sessionStorage.removeItem("pilot_code_specific");
    sessionStorage.removeItem("operator_id");
    sessionStorage.removeItem("operator_code");
    setCurrentUser(undefined);
    Navigate("/login");
    window.location.reload();
  };
  //console.log()
  return (
    <div>
      {isAdmin ? ( /// UTM and Caat
        <div className="Admin">
          {isUTM ? ( ///UTM
            <>
              {logincheck ? (
                <UTMNav
                  logo_dronewhite={logo_dronewhite}
                  isUTM={isUTM}
                  currentUser={currentUser}
                  logOut={logOut}
                  show={show}
                  showDropdown={showDropdown}
                  hideDropdown={hideDropdown}
                  showPilot={showPilot}
                  showDropdownPilot={showDropdownPilot}
                  hideDropdownPilot={hideDropdownPilot}
                  showOperation={showOperation}
                  showDropdownOperation={showDropdownOperation}
                  hideDropdownOperation={hideDropdownOperation}
                  showProfile={showProfile}
                  showDropdownProfile={showDropdownProfile}
                  hideDropdownProfile={hideDropdownProfile}
                />
              ) : (
                ""
              )}
            </>
          ) : (
            ///Caat
            <>
              {logincheck ? (
                <CaatNav
                  logo_dronewhite={logo_dronewhite}
                  isCaat={isCaat}
                  currentUser={currentUser}
                  logOut={logOut}
                  show={show}
                  showDropdown={showDropdown}
                  hideDropdown={hideDropdown}
                  showPilot={showPilot}
                  showDropdownPilot={showDropdownPilot}
                  hideDropdownPilot={hideDropdownPilot}
                  showOperation={showOperation}
                  showDropdownOperation={showDropdownOperation}
                  hideDropdownOperation={hideDropdownOperation}
                  showProfile={showProfile}
                  showDropdownProfile={showDropdownProfile}
                  hideDropdownProfile={hideDropdownProfile}
                />
              ) : (
                ""
              )}
            </>
          )}

          <main style={{ fontFamily: "Kanit" }}>{children}</main>
        </div>
      ) : (
        ///Agency  and  User
        <div>
          {isAgency ? ( /// Agency and User
            <div>
              {logincheck ? ( ///Agency
                <AgencyNav
                  logo_dronewhite={logo_dronewhite}
                  isCaat={isCaat}
                  currentUser={currentUser}
                  logOut={logOut}
                  showOperation={showOperation}
                  showDropdownOperation={showDropdownOperation}
                  hideDropdownOperation={hideDropdownOperation}
                  showProfile={showProfile}
                  showDropdownProfile={showDropdownProfile}
                  hideDropdownProfile={hideDropdownProfile}
                />
              ) : (
                ""
              )}
            </div>
          ) : (
            <>
              {isCorporation ? (
                <>
                  <div>
                    {logincheck ? ( ///User
                      <CorporationNav
                        logo_dronewhite={logo_dronewhite}
                        show={show}
                        showDropdown={showDropdown}
                        hideDropdown={hideDropdown}
                        showPilot={showPilot}
                        showDropdownPilot={showDropdownPilot}
                        hideDropdownPilot={hideDropdownPilot}
                        showOperation={showOperation}
                        showDropdownOperation={showDropdownOperation}
                        hideDropdownOperation={hideDropdownOperation}
                        currentUser={currentUser}
                        showProfile={showProfile}
                        showDropdownProfile={showDropdownProfile}
                        hideDropdownProfile={hideDropdownProfile}
                        logOut={logOut}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div>
                    {logincheck ? ( ///User
                      <UserNav
                        logo_dronewhite={logo_dronewhite}
                        show={show}
                        showDropdown={showDropdown}
                        hideDropdown={hideDropdown}
                        showPilot={showPilot}
                        showDropdownPilot={showDropdownPilot}
                        hideDropdownPilot={hideDropdownPilot}
                        showOperation={showOperation}
                        showDropdownOperation={showDropdownOperation}
                        hideDropdownOperation={hideDropdownOperation}
                        currentUser={currentUser}
                        showProfile={showProfile}
                        showDropdownProfile={showDropdownProfile}
                        hideDropdownProfile={hideDropdownProfile}
                        logOut={logOut}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </>
              )}
            </>
          )}

          <Static_modal
            modalwaiting={modalToggle.modalwait}
            modalErr={modalToggle.modalErr}
            modalSuccess={modalToggle.modalSuccess}
            modalDenied={modalToggle.modalDenied}
            textBody={textBody}
            getHandle={handleClose_Modal}
          />
          <Modal
            show={loading}
            centered
            onHide={handleClose}
            style={{ background: "rgba(0,0,0,0.9)" }}
          >
            <Modal.Body
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "black",
              }}
            >
              <Spinner animation="border" role="status"></Spinner>
            </Modal.Body>
          </Modal>
          <main style={{ fontFamily: "Kanit" }}>{children}</main>
        </div>
      )}
    </div>
  );
};

export default Navbar3;
